var map = {
	"./about-card.de-CH.json": 1458,
	"./about-card.de-DE.json": 1459,
	"./about-card.en-CA.json": 1460,
	"./about-card.en-GB.json": 1461,
	"./about-card.en-IN.json": 1462,
	"./about-card.en-ME.json": 1463,
	"./about-card.en-US.json": 1464,
	"./about-card.es-EM.json": 1465,
	"./about-card.es-ES.json": 1466,
	"./about-card.fr-BE.json": 1467,
	"./about-card.fr-CA.json": 1468,
	"./about-card.fr-CH.json": 1469,
	"./about-card.nl-BE.json": 1470,
	"./about-card.nl-NL.json": 1471,
	"./about-card.pl-PL.json": 1472,
	"./about-card.pt-BR.json": 1473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1457;